import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { UserContextService } from "../services/user-context.service";

/*
The JWT interceptor intercepts the incoming requests from the application/user and adds JWT token to the request's Authorization header, 
only if the user is logged in.

This JWT token in the request header is required to access the SECURE END API POINTS on the server 
*/

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private userContext: UserContextService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // check if the current user is logged in
    /* if the user making the request is logged in, he will have JWT token in it's local storage,
        which is set by Authorization Service during login process*/
    const plancUser = JSON.parse(localStorage.getItem("plancUser"));
    if (plancUser && plancUser.Token) {
      // clone the incoming request and add JWT token in the cloned request's Authorization Header
      /** Remplacement des blancs par $* car ils sont systématiquement supprimés dans les httpHeader ex: 'MFLS '*/
      request = request.clone({
        headers: request.headers
          .set("Authorization", "Bearer " + plancUser.Token)
          .set(
            "siteConnexion",
            this.userContext?.siteConnexion
              ? this.userContext?.siteConnexion.replace(" ", "$*")
              : ""
          )
          .set(
            "base",
            this.userContext?.baseConnexion
              ? this.userContext?.baseConnexion
              : ""
          ),
      });
    }

    // handle any other requests which went unhandled
    return next.handle(request);
  }
}
